import React from 'react';
import { Collapse } from 'antd';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/store';
import EnhancedTable from './EnhancedTable';
import { EMPTY_MESSAGES, TABLE_COLUMNS, EXPORT_TYPES } from './constants';
import type { Device } from './types';

const { Panel } = Collapse;

interface DevicesSectionProps {
  isOpen: boolean;
  onExport?: () => void;
}

const DevicesSection: React.FC<DevicesSectionProps> = ({ isOpen, onExport }) => {
  const { devices, loading } = useSelector((state: RootState) => state.adminReports);

  const tableData = devices.map((d: Device) => ({
    'Device Name': d.name || 'N/A',
    Identifier: d.identifier || 'N/A',
    Type: d.type?.name || 'Unknown',
    Status: d.status !== undefined ? d.status : true,
  }));

  return (
    <Collapse activeKey={isOpen ? ['devices'] : []} ghost>
      <Panel key="devices" header="" showArrow={false}>
        <EnhancedTable
          data={tableData}
          columns={[...TABLE_COLUMNS.DEVICES]}
          title={EXPORT_TYPES.ACTIVE_DEVICES}
          emptyMessage={EMPTY_MESSAGES.DEVICES}
          onExport={onExport}
          loading={loading}
        />
      </Panel>
    </Collapse>
  );
};

export default DevicesSection;
